import React from 'react';
import { classnames } from '@/utils/classnames/classnames';

interface CategoryIconProps {
  src?: string;
  className?: string;
}

/**
 * Renders a (monochrome) category icon via CSS mask + `bg-current`, so it
 * inherits `currentColor` and flips to white on the highlighted (navy) card.
 * SVGR-inlining an authored media URL isn't possible at runtime, so the mask is
 * the runtime-safe way to honour the spec's currentColor requirement. Authored
 * icons should be single-colour/alpha line icons (per the spec).
 */
const CategoryIcon = ({ src, className }: CategoryIconProps) => {
  if (!src) return null;

  const maskUrl = `url("${src}")`;

  return (
    <span
      aria-hidden
      className={classnames('inline-block size-8 bg-current', className)}
      style={{
        maskImage: maskUrl,
        WebkitMaskImage: maskUrl,
        maskRepeat: 'no-repeat',
        WebkitMaskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskSize: 'contain',
      }}
    />
  );
};

export default CategoryIcon;
